export default {
  googleSheets: []
}
